<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("inventory_transfer") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <form-clear-button :disabled="isLoading" @click="clearForm" />
          <base-button size="md" type="neutral" @click="handleBack()">{{
            $t("back")
          }}</base-button>
          <base-button size="md" type="primary" :loading="isLoading" @click="handlInventoryTransfer()">{{
            $t("save")
          }}</base-button>
        </div>
      </div>
    </base-header>

    <div class="row">
      <div class="container-fluid mt--6 col-lg-6">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <h3 class="mb-0">คลังปลายทาง : {{ StorageName }}</h3>
            </template>

            <div class="form-group row">
              <label class="col-md-3 pl-6 col-form-label form-control-label">
                {{ $t("wms.note") }}
              </label>
              <div class="col-md-8">
                <base-input v-model="inOut.Note"></base-input>
              </div>
            </div>

            <div
              class="form-group row"
              v-for="(item,index) in ProductSelect"
              :key="item.ID"
            >
              <label class="col-md-6 pl-6 col-form-label form-control-label">
                {{ item.Name }}
              </label>
              <div class="col-md-3">
                <base-input v-model="item.Quantity"></base-input>
              </div>
              <div class="col-md-3">
                <base-button
                  @click.native="handleDelete(index, item)"
                  class="remove btn-link"
                  type="danger"
                  size="md"
                  icon
                >
                  <i class="text-dtac-bt fa fa-trash text-white"></i>
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="container-fluid mt--6 col-lg-6">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <div class="row">
                <label class="col-md-6 col-form-label form-control-label">
					<h3 class="mb-0">คลังต้นทาง : {{ RetailStorageName }}</h3>
                </label>
                <div class="col-md-6">
                  <base-input
                    v-model="SearchKeyword"
                    prepend-icon="fas fa-search"
                    :placeholder="$t('search')"
                  >
                  </base-input>
                </div>
              </div>
            </template>
            <div>
          
              <el-table
                :data="queriedData"
                row-key="id"
                header-row-class-name="thead-light"
                @sort-change="sortChange"
                @selection-change="selectionChange"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  v-bind="column"
                >
                </el-table-column>

                <el-table-column
                  min-width="200px"
                  align="right"
                  :label="$t('actions')"
                >
                  <div slot-scope="{ $index, row }" class="d-flex">
                    <base-button
                      @click.native="handleOut($index, row)"
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
                    >
                      <i class="text-dtac-bt fa fa-edit"></i>
                      {{ $t("wms.inventory_out") }}
                    </base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
			  v-if="tableData.length != 0"
            >
              <div class="">
                <p class="card-category">
                  {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                  {{ $t("of") }}
                  {{ total }}
                  <span v-if="selectedRows.length">
                    - &nbsp; &nbsp; {{ selectedRows.length }}
                    {{ $t("row_select") }}
                  </span>
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              >
              </base-pagination>
            </div>
          </card>
        </div>
      </div>
    </div>









<!--  Modal -->
    <modal :show.sync="showInOutModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input v-model="inOut.ProductName" :label="$t('wms.product')">
        </base-input>

        <base-input
          v-model="inOut.Quantity"
          :label="$t('wms.amount')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdateSelect()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showInOutModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import wmsProductRefetchOnActivate from "@/mixins/wmsProductRefetchOnActivate";
import { activeProductIdSet, filterRowsByActiveProducts } from "@/utils/wmsProductActive";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from '@/components/Inputs/FileInput'
import formDraft from "@/mixins/formDraft";
import FormClearButton from "@/components/FormClearButton";

export default {
  mixins: [clientPaginationMixin, formDraft, wmsProductRefetchOnActivate],
  components: {
    FormClearButton,
      FileInput,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "WmsInventory/getData",
      Product: "WmsProduct/getData",
      Storage: "WmsStorage/getData",
      getUser: "Auth/getUser" ,
    }),
    // #421 §7.1 F7b: WmsInventory rows come from go-wms with no is_active filter;
    // keep only rows of active products (null = product list not loaded -> no filter).
    activeProductIds() {
      return activeProductIdSet(this.Product);
    },
    tableData: function () {
      if (this.SearchKeyword != "") {
        return filterRowsByActiveProducts(this.tableDataOrg, this.activeProductIds).filter((d) => {
          return (
            d.StorageID == this.RetailStorageID &&
            (d.ProductName.toLowerCase().indexOf(this.SearchKeyword.toLowerCase()) != -1 || d.Barcode.indexOf(this.SearchKeyword) != -1)
          );
        });
      } else {
        return filterRowsByActiveProducts(this.tableDataOrg, this.activeProductIds).filter((d)=>{
          return d.StorageID == this.RetailStorageID
        });
      }

    },
    StorageDst : function (){
      return this.Storage.filter((d)=>{
        return d.ID != 1
      });
    },
    tableColumns: function () {
      return [
        {
          prop: "ProductName",
          label: this.$t("wms.product"),
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "Balance",
          label: this.$t("wms.balance"),
          minWidth: 120,
          sortable: true,
        },
		{
          prop: "Barcode",
          label: this.$t("wms.barcode"),
          minWidth: 120,
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
	  isLoading: false,
      StorageID: 0,
	  RetailStorageID:0,
      StorageName: "",
	  RetailStorageName:"",
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      showAddModal: false,
      showInOutModal: false,
      SearchKeyword: "",
      md: {
        InventoryID: 0,
        ProductID: "-",
        StorageID: "-",
        Note: "",
        Quantity: "0",
        Cost: 0,
      },
      inOut: {
        InventoryID: 0,
        ProductID: 0,
        StorageID: 0,
        Note: "",
        Quantity: 0,
        Cost: 0,
        Action: "",
        BillFile: null,
        BillCode: "",
      },
      rowEdit: {
        ID: 0,
        Number: "",
      },
      ProductSelect: [],
    };
  },
  async mounted() {
    this.listData();
    this.listProduct();
    this.listStorage();
    this.pagination.perPage = 10;

	// Get User Profile
	try {
		let resp = await this.getProfile()
		let user = resp.data.Datum
		console.log(user)
		this.StorageID = user.wms_storage_id
		this.StorageName = user.wms_storage_name
		this.RetailStorageID = user.fix_wms_retail_storage_id
		this.RetailStorageName = user.fix_wms_retail_storage_name


		if (this.StorageID == 0 || this.RetailStorageID == 0 ) {
			swal.fire({
				title: "ผู้ใช้งานนี้ยังไม่ได้ตั้งค่าคลังสินค้า",
				text: "กรุณาติดต่อผู้ดูแลระบบเพื่อตั้งค่าคลังสินค้า",
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false,
			}).then(()=>{
				this.$router.go(-1)
			})

		}
	} catch (err){
		swal.fire({
            title: "ตรวจสอบข้อมูลคลังสินค้าผิดพลาด",
            text: "กรุณาติดต่อผู้ดูแลระบบเพื่อตั้งค่าคลังสินค้า",
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false,
          }).then(()=>{
			this.$router.go(-1)
		  })
	}

  },
  methods: {
    ...mapActions({
      InventoryIn: "WmsInventory/InventoryIn",
      InventoryOut: "WmsInventory/InventoryOut",
      InventoryTransfer: "WmsInventory/InventoryTransferByUser",
      listData: "WmsInventory/listData",
      listProduct: "WmsProduct/listData",
      listStorage: "WmsStorage/listData",
	  getProfile : "Auth/getProfile",
    }),
    // #421 §7.1 F7b (wmsProductRefetchOnActivate): on return to this kept-alive tab
    // reload the product list (row filter) and the inventory rows (balances).
    refetchWmsProducts() {
      return Promise.all([this.listProduct(), this.listData()]);
    },
    handleUpdateSelect() {
      this.showInOutModal = false;

      let amount = parseInt(this.inOut.Quantity);
      if (isNaN(amount)) {
        return;
      }

      let f = this.ProductSelect.filter(
        (d) => d.InventoryID === this.inOut.InventoryID
      );
      if (f.length != 0) {
        let index = this.ProductSelect.indexOf(f[0]);
        this.ProductSelect[index].Quantity += amount;
      } else {
        this.ProductSelect.push({
          Name: this.inOut.ProductName,
          InventoryID: parseInt(this.inOut.InventoryID),
          ProductID: parseInt(this.inOut.ProductID),
          StorageID: 0,
          Quantity: amount,
        });
      }
    },
    handleBack() {
		this.$router.go(-1);
    },
    handleOut(index, row) {
      this.showInOutModal = true;
      this.inOut.InventoryID = parseInt(row.ID);
      this.inOut.ProductID = parseInt(row.ProductID);
      this.inOut.StorageID = 0;
      this.inOut.ProductName = row.ProductName;
    },
    handlInventoryTransfer() {
      this.showInOutModal = false;
	  this.isLoading = true;

	//   Check ProductSelect Quantity is integer
		let f = this.ProductSelect.filter((d)=>{
			return !/^\d+$/.test(d.Quantity);
		})
		if (f.length != 0) {
			swal.fire({
			title: "จำนวนสินค้าไม่ถูกต้อง",
			text: "",
			icon: "error",
			confirmButtonClass: "btn btn-danger btn-fill",
			buttonsStyling: false,
			});
			this.isLoading = false;
			return
		}

      let data = this.ProductSelect.map((d)=>{
          return {
            product_id : d.ProductID,
            quantity : parseInt(d.Quantity),
          }
        })

		if (data.length == 0 ) {
			swal.fire({
            title: "กรุณาเลือกสินค้า",
            text: "",
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false,
          });
		  this.isLoading = false;
		  return
		}

		let payload = {
			list : data,
			note : this.inOut.Note
		}


      this.InventoryTransfer(payload)
        .then((resp) => {
          this.listData();
          // §4: empty the cached tab before the swal + redirect.
          this.afterSaveReset();
          swal.fire({
            title: "เบิกสินค้าสำเร็จ",
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          }).then(()=>{
			this.$router.go(-1);
            });
        })
        .catch((err) => {
		  this.isLoading = false;
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: err.response.data.Cause,
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false,
          });
        });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
			// remove at index
			console.log("remove by index", index)
			this.ProductSelect.splice(index, 1);
        });
    },

    // Spec 2026-10-07-bo-form-draft-clear-design.md §4 A4: back to a fresh
    // tab — note, added products and their quantities, search box,
    // pagination, modals, isLoading. The source/destination warehouses come
    // from the user profile in mounted() (not user input) and are kept.
    resetForm() {
      const fromProfile = {
        StorageID: this.StorageID,
        StorageName: this.StorageName,
        RetailStorageID: this.RetailStorageID,
        RetailStorageName: this.RetailStorageName,
      };
      Object.assign(this.$data, this.$options.data.call(this), fromProfile);
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
     filesChange(files) {
      console.log(files[0])
        this.inOut.BillFile = files[0]
    }
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
